/**
 * 名前空間 `creditorExports` — 債権者の CSV・一覧表 PDF・宛名ラベル PDF の取得のトースト (slice p2-06)。
 * 文言は `locales/ja/creditorExports.ts` (正本) と `locales/en/creditorExports.ts`。hook は `useT(creditorExportsNs)`。
 * 債権者タブの `creditors` と分けている理由は `locales/ja/creditorExports.ts` の説明 (main chunk の大きさ)。
 */
import { defineNamespace } from '../registry';
import { creditorExportsEn } from '../locales/en/creditorExports';
import { creditorExportsJa } from '../locales/ja/creditorExports';

export const creditorExportsNs = defineNamespace(
  'creditorExports',
  creditorExportsJa,
  creditorExportsEn,
);
